export const ERROR_QUESTION_INDEX = 0;
export const EMPTY_ERROR_ARRAY = new Array(5).fill(false);
export const MAX_QUESTION_LENGTH = 150;
export const MAX_OPTION_LENGTH = 25;
export const MAX_POLL_OPTIONS = 4;
export const DURATION_OPTIONS = ['1', '2', '3', '4', '5', '6', '7'];
export const EMPTY_POLL_DATA = {
    question: '',
    options: [{ text: '' }, { text: '' }],
    openDays: 7,
};
//# sourceMappingURL=constants.js.map